import _objectSpread from "/home/vsts/work/r1/a/_CoveredCA_CoveredCalifornia-Cici-FrontEnd/node_modules/@babel/runtime/helpers/esm/objectSpread";
import platform from './node/index.js';
import * as utils from './common/utils.js';
export default _objectSpread({}, utils, platform);